<template>
    <div>
        <hts-data-table
            ref="tables"
            :headers="headers"
            :server="apiGetUsers"
            :auto-size="autoSizeTable" />
        <hts-drawer
            v-model="editRoleVisible"
            :submit="updateRoles"
            :title="$t('labels.roles')">
            <hts-form-select
                v-model="editRoleData.roles"
                multiple
                :items="roles" />
        </hts-drawer>
    </div>
</template>
<script lang="ts" setup>
const editRoleVisible = ref(false)
const editRoleId = ref(null)
const editRoleData = reactive({
  roles: []
})
const roles = ref([
  { label: $t('labels.superAdmin'), value: 'super' },
  { label: $t('labels.taskAndJob2'), value: 'business_task_management' },
  { label: $t('labels.workflow'), value: 'workflow_management' },
  { label: $t('labels.settings'), value: 'setting_management' },
  { label: $t('labels.vehicleCategory'), value: 'vehicle_category_management' },
  { label: $t('labels.node'), value: 'node_management' },
  { label: $t('labels.user'), value: 'user_management' }
])
const autoSizeTable = {
  active: false,
  skipHeader: false
}

const handleEditRoles = ({ _id, roles }: any) => {
  editRoleId.value = _id
  editRoleData.roles = roles || []
  editRoleVisible.value = true
}
const updateRoles = async () => {
  await $api($urlSystem.user.updateRoles, { uriParams: { ID: editRoleId.value }, body: editRoleData })
  refreshTables()
  editRoleVisible.value = false
}
const tables = ref()
const refreshTables = () => {
  if (tables.value) {
    tables.value.refresh()
  }
}
const apiGetUsers = $urlSystem.user.getList
const headers = [
  {
    field: 'fullName',
    headerName: $t('labels.name'),
    sortable: true,
    filter: 'agTextColumnFilter',
    minWidth: 150
  },
  {
    field: 'username',
    headerName: $t('labels.username'),
    filter: 'agTextColumnFilter',
    sortable: true,
    minWidth: 150
  },
  {
    field: 'registerBy',
    headerName: $t('labels.type'),
    filter: 'agTextColumnFilter',
    sortable: true,
    minWidth: 150
  },
  {
    field: 'roles',
    headerName: $t('labels.roles'),
    autoHeight: true,
    minWidth: 150,
    valueGetter: (params: any) => {
      if (!Array.isArray(params.data.roles)) {
        return ''
      }
      const text: any[] = []
      params.data.roles.forEach((i: any) => {
        const item = roles.value.find((role: any) => role.value === i)
        text.push(item?.label)
      })
      return text.join(', ')
    }
  },
  {
    field: 'createdAt',
    headerName: $t('labels.createdAt'),
    sortable: true,
    minWidth: 180
  },
  {
    field: 'action',
    pinned: 'right',
    sortable: false,
    lockPosition: true,
    lockPinned: true,
    popup: true,
    suppressRowTransform: true,
    suppressMenu: true,
    resizable: false,
    headerName: $t('labels.action'),
    cellStyle: { overflow: 'visible' },
    cellRenderer: 'Actions',
    cellRendererParams: {
      storeKey: 'businessDataTable',
      storeName: 'Business',
      items: [
        {
          icon: 'hi-pencil-icon',
          label: $t('labels.roles'),
          class: 'text-blue-600 hover:text-blue-500',
          permissions: checkPermissionAdmin('user_management'),
          click: handleEditRoles
        }
      ]
    }
  }
]
</script>
